import { AttachmentCommonUpload, Breadcrumb, Card, Col, EventHandler, Label, ModalPopup, OutlineButton, PrimaryButton, ReactSelectBox, Row, SwitchToggle, Tooltip } from "client/CommonComponents";
import './CreateAsset.scss';
import AssetType from "./AssetType";
import BudgetInformation from "./BudgetInformation";
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import KitAttribute from "./KitAttribute";
import MowerAttribute from "./MowerAttribute";
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { formatPrice } from "utils";
import AddFilter from "./AddFilter";
import AddModel from "./AddModel";
import AddEqClassCode from "./AddEqClassCode";
import permissions, { isAuthorized } from "client/utils/Permissions";
import EditFilter from "./EditFilter";
const CreateAsset = (props: any) => {
    const {
        selectedAssetType,
        handleNAPChange,
        catalogItemValues,
        setCatalogItemValues,
        vehicleTypeList,
        capacityList,
        noOfDoorsList,
        makeList,
        modelsList,
        upfitOptionList,
        driveTrainList,
        snowSetupList,
        powerTypeList,
        eqClassCodeList,
        vehicleLevelList,
        yearList,
        categoryList,
        deckSizeList,
        deckTypeList,
        stateAvailabilityList,
        programStatusList,
        annualHoursList,
        autonomousList,
        budgetPercentList,
        useFulLifeList,
        statusOptions,
        onChangeStatus,
        setCatalogItemErrors,
        catalogItemErrors,
        validateCatalogItemValues,
        onUploadClick,
        attachmentsList,
        onRemoveAttachment,
        vehicleTypeDropdown,
        id,
        catalogItemByAssetModelId = {},
        setKitAttributeValues,
        kitAttributeValues,
        getTotalKitPrice,
        validateAddedKitValues,
        getGLCode,
        getRequestTypeForEditScreen,
        sizeList,
        lengthList,
        seatingCapacityList,
        enclosedCabList,
        classTypeList,
        groupTypeList,
        cdlList,
        grossWeightList,
        vehicleClassList,
        useList,
        trimList,
        category2List,
        categoryTypeList,
        constructionEquipmentWithSubCategory,
        standardizedEquipmentWithSubCategory,
        snowWithSubCategory,
        ExistingDropDownValue,
        handleClickModelAdd,
        handleClickAddModel,
        selectedModel,
        setSelectedModel,
        setSelectedMake,
        selectedMake,
        showAddModelModal,
        setShowAddModelModal,
        filterName,
        setFilterModelPopup,
        filterModelPopup,
        showEditPopup,
        hideDialogComplete,
        PopupcontentComplete,
        filterEqClassCodePopup,
        setEqClassCodePopup,
        handleEqClassCodeAdd,
        setEqClassCode,
        eqClassCode,
        setEqClassDescription,
        eqClassDescription,
        setAddEqClassCodeError,
        addEqClassCodeError,
        setAddEqClassDescriptionError,
        addEqClassDescriptionError,
        modelError,
        setModelError,
        validateEqClassValues,
        setFieldValueError,
        fieldValueError,
        validateModel,
        setModelMakeError,
        modelMakeError,
        typeList,
        editFilterModel,
        setShowEditPopup,
        actionType
    } = props
    return (
        <>
            <div className='breadCrumbBlock mb-2'>
                <EventHandler onEvent={props.handleClickCancel} data-attribute="CreateAsset_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span> Back
                    </div>
                </EventHandler>
                <div className='breadcrumbList'>
                    <Breadcrumb items={props.breadcrumlist} maxDisplayedItems="5"  data-attribute="CreateAsset_Default_Breadcrumb" />
                </div>
            </div>
            <div className="mb-3 DropDownAlligment create-new-asset-block">
                <Card data-attribute="CreateAsset_Default_Card">

                    {!id &&
                        <>
                            <p className='headingText mb-0'>CREATE NEW ASSET TYPE</p>
                            <p className='subText mb-2'>Select below options to create new asset type</p>

                            <Row className="pe-xl-4">
                                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-lg-3 mb-md-0 mb-3'>
                                    <Label required data-attribute="CreateAsset_Default_Label">Asset Type</Label>
                                    <div className="asset-type-btn-block">
                                        <ReactSelectBox
                                            placeholder="Select Asset Type"
                                            options={props?.assetTypeOption}
                                            value={props?.assetTypeOption?.value}
                                            onChange={props?.onChangeAssetType}
                                            className={selectedAssetType?.assetTypeError ? 'controlValidation' : "" }
                                         data-attribute="CreateAsset_Default_SearchSelectBox" />
                                        <PrimaryButton text='Add Item' className='pull-right add-item-catalog' onClick={props?.onClickAddItemBtn}  data-attribute="CreateAsset_Default_Button" />
                                    </div>
                                    {selectedAssetType?.assetTypeError ? <p className='validMessage'>{selectedAssetType?.assetTypeError}</p> : ""}
                                </Col>
                            </Row>
                        </>
                    }
                    {id &&
                        <>
                            <div className="edit-asset-block">
                                <p className='headingText mb-2'>{actionType == 'edit' ? 'EDIT' : 'COPY'} ASSET</p>
                                <div>
                                    <Label required data-attribute="CreateAsset_Default_Label_2">{catalogItemByAssetModelId?.requestType} Type</Label>
                                    <Tooltip content={getRequestTypeForEditScreen(catalogItemByAssetModelId?.orderRequestSubTypeId) ?? '-'} data-attribute="CreateAsset_Default_Tooltip">
                                        <span>{getRequestTypeForEditScreen(catalogItemByAssetModelId?.orderRequestSubTypeId) ?? '-'}</span>
                                    </Tooltip>

                                </div>
                                <div>
                                    <Label required data-attribute="CreateAsset_Default_Label_3">Description</Label>
                                    <Tooltip content={catalogItemByAssetModelId?.catalogDescription ?? "-"}  data-attribute="CreateAsset_Default_Tooltip_2">
                                        <span>{catalogItemByAssetModelId?.catalogDescription ?? '-'}</span>
                                    </Tooltip>

                                </div>
                                <div>
                                    <Label required data-attribute="CreateAsset_Default_Label_4">Order Price</Label>
                                    <Tooltip content={`$${formatPrice(catalogItemByAssetModelId?.price, 2)}`} data-attribute="CreateAsset_Default_Tooltip_3">
                                        <span>{`$${formatPrice(catalogItemByAssetModelId?.price, 2)}`}</span>
                                    </Tooltip>
                                </div>
                                <div>
                                    <Label required data-attribute="CreateAsset_Default_Label_5">Monthly Expenses</Label>
                                    <Tooltip content={`$${formatPrice(catalogItemByAssetModelId?.budgetInfo?.monthlyDepreciation, 2)}`} data-attribute="CreateAsset_Default_Tooltip_4">
                                        <span>{`$${formatPrice(catalogItemByAssetModelId?.budgetInfo?.monthlyDepreciation, 2)}`}</span>
                                    </Tooltip>
                                </div>
                            </div>
                        </>}
                </Card>
            </div>
            {
                props?.addItemClicked ?
                    <div className="DropDownAlligment vehicle-type-block">
                        <Card data-attribute="CreateAsset_Default_Card_2">
                            <div className="Vehicle-type-section">
                                <div className="vehicle-header-block">
                                    <div className="left-block">
                                        <p className="headingText pull-left mb-0">{(selectedAssetType?.assetType?.value?.toUpperCase())}</p>
                                        <p className="subText mb-0">Fill asset details</p>
                                    </div>
                                    <div className="right-block main-container">
                                        <div className="right-block me-sm-3 mb-sm-0 mb-2">
                                            <span className="fs-12 nap me-2">No National Accounting Price</span>
                                            <SwitchToggle
                                                className="mt-1 mb-0"
                                                checked={!!catalogItemValues?.nap}
                                                onChange={(e: any, value: boolean) => handleNAPChange(e, value)}
                                             data-attribute="CreateAsset_Default_SwitchToggle" />
                                        </div>
                                        <div className="status-block">
                                            <ReactSelectBox
                                                name='status'
                                                placeholder="Select Status"
                                                options={statusOptions}
                                                value={catalogItemValues?.status || ''}
                                                onChange={onChangeStatus}
                                                className={catalogItemErrors?.status ? 'controlValidation' : "" }
                                             data-attribute="CreateAsset_status_SearchSelectBox" />
                                            {catalogItemErrors?.status ? <p className='validMessage'>{catalogItemErrors?.status}</p> : ""}
                                        </div>                                       
                                        <div className="purchaseorder-attachement catalogmanagement">
                                            <div className={`attachment-container ms-3`}>
                                                <div className="pull-right">
                                                    <AttachmentCommonUpload
                                                        link={true}
                                                        list={props?.list}
                                                        setList={props?.setList}
                                                        uploadBtnClick={onUploadClick}
                                                        multiple={true}
                                                        error={props?.error}
                                                        setError={props?.setError}
                                                        maxSize={5}
                                                        iAttachmentEditable={true}
                                                        uploadedList={attachmentsList}
                                                        tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                                                        onRemove={onRemoveAttachment}
                                                        isDownloadable = {true}
                                                     data-attribute="CreateAsset_Default_AttachmentCommonUpload" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="vehicle-content-block">
                                    <AssetType
                                        assetTypeValue={selectedAssetType?.assetType?.value}
                                        selectedAssetType={selectedAssetType}
                                        catalogItemValues={catalogItemValues}
                                        setCatalogItemValues={setCatalogItemValues}
                                        vehicleTypeList={vehicleTypeList}
                                        capacityList={capacityList}
                                        noOfDoorsList={noOfDoorsList}
                                        makeList={makeList}
                                        modelsList={modelsList}
                                        upfitOptionList={upfitOptionList}
                                        driveTrainList={driveTrainList}
                                        snowSetupList={snowSetupList}
                                        powerTypeList={powerTypeList}
                                        eqClassCodeList={eqClassCodeList}
                                        vehicleLevelList={vehicleLevelList}
                                        yearList={yearList}
                                        categoryList={categoryList}
                                        setCatalogItemErrors={setCatalogItemErrors}
                                        catalogItemErrors={catalogItemErrors}
                                        validateCatalogItemValues={validateCatalogItemValues}
                                        vehicleTypeDropdown={vehicleTypeDropdown}
                                        sizeList={sizeList}
                                        lengthList={lengthList}
                                        seatingCapacityList={seatingCapacityList}
                                        enclosedCabList={enclosedCabList}
                                        classTypeList={classTypeList}
                                        groupTypeList={groupTypeList}
                                        cdlList={cdlList}
                                        grossWeightList={grossWeightList}
                                        vehicleClassList={vehicleClassList}
                                        trimList={trimList}
                                        category2List={category2List}
                                        categoryTypeList={categoryTypeList}
                                        constructionEquipmentWithSubCategory={constructionEquipmentWithSubCategory}
                                        standardizedEquipmentWithSubCategory={standardizedEquipmentWithSubCategory}
                                        snowWithSubCategory={snowWithSubCategory}

                                        filterName={props.filterName}
                                        setFilterName={props.setFilterName}
                                        filterModelPopup={props.filterModelPopup}
                                        showEditPopup = {showEditPopup}
                                        onPopupFilterModel={props.onPopupFilterModel}
                                        setFilterModelPopup={props.setFilterModelPopup}
                                        ExistingDropDownValue = {ExistingDropDownValue}
                                        handleClickAddModel = {handleClickAddModel}
                                        typeList={typeList}
                                        editFilterModel = {editFilterModel}
                                    />
                                    {selectedAssetType?.assetType?.value === CONSTANTS.MOWER ||
                                        selectedAssetType?.assetType?.value === CONSTANTS.UTILITY_VEHICLE ||
                                        selectedAssetType?.assetType?.value === CONSTANTS.STANDARIZED_EQUIPMENT ?
                                        <MowerAttribute
                                            assetTypeValue={selectedAssetType?.assetType?.value}
                                            stateAvailabilityOption={stateAvailabilityList}
                                            programStatusOption={programStatusList}
                                            annualHoursOption={annualHoursList}
                                            autonomousList={autonomousList}
                                            desckSizeOption={deckSizeList}
                                            deckTypeOption={deckTypeList}
                                            autonomousOption={autonomousList}
                                            catalogItemValues={catalogItemValues}
                                            setCatalogItemValues={setCatalogItemValues}
                                            catalogItemErrors={catalogItemErrors}
                                            validateCatalogItemValues={validateCatalogItemValues}

                                            filterName={props.filterName}
                                            setFilterName={props.setFilterName}
                                            filterModelPopup={props.filterModelPopup}
                                            onPopupFilterModel={props.onPopupFilterModel}
                                            setFilterModelPopup={props.setFilterModelPopup}
                                        /> : ''}
                                    <BudgetInformation
                                        assetTypeValue={selectedAssetType?.assetType?.value}
                                        selectedAssetType={selectedAssetType}
                                        budgetPercentList={budgetPercentList}
                                        useFulLifeList={useFulLifeList}
                                        setCatalogItemValues={setCatalogItemValues}
                                        catalogItemValues={catalogItemValues}
                                        setCatalogItemErrors={setCatalogItemErrors}
                                        catalogItemErrors={catalogItemErrors}
                                        validateCatalogItemValues={validateCatalogItemValues}
                                        getGLCode={getGLCode}
                                        useList={useList}

                                        onPopupFilterModel={props.onPopupFilterModel}
                                    />
                                    <div className="Kit-attribute-toggle">
                                        <div className="toggle-btn">
                                            <b className="headtxt">Kit Attributes</b>
                                            <SwitchToggle checked={props?.showKitAttributeTable} className="ms-3" onChange={props?.handleOnChangeKitToggle}  data-attribute="CreateAsset_Default_SwitchToggle_2" />
                                        </div>
                                        <div className="toggle-error">
                                            {catalogItemErrors?.kitTotalError ? <p className='validMessage ms-md-3'>{catalogItemErrors?.kitTotalError}, </p> : ""}
                                            {catalogItemErrors?.kitError ? <p className='validMessage ms-md-3'>{catalogItemErrors?.kitError}</p> : ""}
                                        </div>                                           
                                    </div> 
                                    {
                                        props?.showKitAttributeTable ? <KitAttribute
                                            setKitAttributeValues={setKitAttributeValues}
                                            kitAttributeValues={kitAttributeValues}
                                            getTotalKitPrice={getTotalKitPrice}
                                            validateAddedKitValues={validateAddedKitValues}
                                            setCatalogItemErrors={setCatalogItemErrors}
                                            catalogItemValues={catalogItemValues}
                                        /> : ''
                                    }

                                </div>
                            </div>
                            <div className="pull-right-btn-block">
                                <OutlineButton text='Cancel' className='me-2' onClick={props?.handleClickCancel}  data-attribute="CreateAsset_Default_Button_2" />
                                <PrimaryButton text={id ? (actionType == 'edit' ? "Update" : "Add") : "Add"} onClick={props?.handleClickAdd} disabled={!isAuthorized(permissions?.CreateEditCatalog)} data-attribute="CreateAsset_Default_Button_3" />
                            </div>
                        </Card>
                    </div> : ''
            }
            <CompleteConfirmationPopup
                hideDialog={hideDialogComplete}
                onDismiss={PopupcontentComplete?.popupOutlinebtnOnclickComplete ? PopupcontentComplete?.popupOutlinebtnOnclickComplete : hideDialogComplete}
                Popupcontent={PopupcontentComplete}
                popupOutlinebtnOnclick={PopupcontentComplete?.popupOutlinebtnOnclickComplete}
                popupPrimarybtnOnclick={PopupcontentComplete?.popupPrimarybtnOnclick}
            />


            {
                filterModelPopup ?
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle={`Add ${filterName == AttributeName.VEHICLE_LEVEL  ? AttributeName.ASSIGNMENT_GROUPS : filterName}`}
                        ModalPopupType="small"
                        closeModalPopup={() => setFilterModelPopup(false)}
                        ModalPopupName="addModel-popup vehicle_classtype_popup"
                     data-attribute="CreateAsset_Default_ModalPopup">
                        <AddFilter
                            catalogItemValues={catalogItemValues}
                            setFilterModelPopup={setFilterModelPopup}
                            filterName={filterName}
                            ExistingDropDownValue={ExistingDropDownValue}
                            selectedAssetType={selectedAssetType}
                            setFieldValueError={setFieldValueError}
                            fieldValueError={fieldValueError}
                        />
                    </ModalPopup> : ''
            }
            {
                showEditPopup ?
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle={`Edit Capacity`}
                        ModalPopupType="small"
                        closeModalPopup={() => setShowEditPopup(false)}
                        ModalPopupName="addModel-popup"
                     data-attribute="CreateAsset_Default_ModalPopup_2">
                        <EditFilter
                            itemList={capacityList}
                            setShowEditPopup={setShowEditPopup}
                            catalogItemValues={catalogItemValues}
                        />
                    </ModalPopup> : ''
            }
            {
                showAddModelModal ?
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        FooterSecondaryBtnTxt="Cancel"
                        FooterPrimaryBtnTxt="Add"
                        PrimaryBtnOnclick={handleClickModelAdd}
                        SecondryBtnOnclick={() => setShowAddModelModal(false)}
                        ModalPopupTitle="ADD MODEL"
                        ModalPopupType="small"
                        closeModalPopup={() => setShowAddModelModal(false)}
                        ModalPopupName="addModel-popup"
                        isFooterPrimaryBtnDisable={!isAuthorized(permissions?.CreateEditCatalog)} 
                     data-attribute="CreateAsset_Default_ModalPopup_3">
                        <AddModel
                            selectedMake={selectedMake}
                            setSelectedModel={setSelectedModel}
                            selectedModel={selectedModel}
                            setSelectedMake={setSelectedMake}
                            catalogItemValues={catalogItemValues}
                            ExistingDropDownValue={ExistingDropDownValue}
                            setShowAddModelModal={setShowAddModelModal}
                            modelError={modelError}
                            setModelError={setModelError}
                            validateModel={validateModel}
                            setModelMakeError={setModelMakeError}
                            modelMakeError={modelMakeError}
                            selectedAssetType = {selectedAssetType}
                        />
                    </ModalPopup> : ''
            }
            {
                filterEqClassCodePopup ?
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        FooterSecondaryBtnTxt="Cancel"
                        FooterPrimaryBtnTxt="Add"
                        PrimaryBtnOnclick={handleEqClassCodeAdd}
                        SecondryBtnOnclick={() => setEqClassCodePopup(false)}
                        ModalPopupTitle="ADD EQ CLASS CODE"
                        ModalPopupType="small"
                        closeModalPopup={() => setEqClassCodePopup(false)}
                        ModalPopupName="addModel-popup"
                        isFooterPrimaryBtnDisable={!isAuthorized(permissions?.CreateEditCatalog)}
                     data-attribute="CreateAsset_Default_ModalPopup_4">
                        <AddEqClassCode
                            catalogItemValues={catalogItemValues}
                            ExistingDropDownValue={ExistingDropDownValue}
                            selectedAssetType={selectedAssetType}
                            setEqClassCode={setEqClassCode}
                            eqClassCode={eqClassCode}
                            setEqClassDescription={setEqClassDescription}
                            eqClassDescription={eqClassDescription}
                            setEqClassCodePopup={setEqClassCodePopup}
                            setAddEqClassCodeError={setAddEqClassCodeError}
                            addEqClassCodeError={addEqClassCodeError}
                            setAddEqClassDescriptionError={setAddEqClassDescriptionError}
                            addEqClassDescriptionError={addEqClassDescriptionError}
                            validateEqClassValues={validateEqClassValues}
                        />
                    </ModalPopup> : ''
            }
        </>
    )
}

export default CreateAsset;